export const carStatuses = {
  incoming: 'incoming',
  active: 'active',
  outgoing: 'outgoing',
  returned: 'returned'
}

export default carStatuses
